@if (isRequest) { <app-complete-request-callback [requestData]="requestData" (continue)="continue()"
    (skip)="skip()"></app-complete-request-callback> } @else { <div class="flex flex-grow container py-8"
    *transloco="let t; prefix: 'onboarding.onboarding-welcome'">
    <div class="flex flex-grow container py-8">
        <div class="flex-grow flex lg:flex-row flex-col lg:items-start items-center justify-center">
            <div class=" flex flex-1 justify-center">
                <div class="flex flex-col rfs:gap-8">
                    <div class="flex flex-col gap-2">
                        <h1 class="text-black text-[2.5rem] leading-[48px]">{{nav == 'home' ? t('header') :
                            t('oneMoreStep')}}</h1>
                        <p class="text-gray-900">{{nav == 'home' ? t('infoText') : nav == 'buyer'? t('infoTextBuyer') :
                            t('infoTextSeller') }}</p>
                    </div>
                    <ng-container *ngIf="nav != 'home'">
                        <div>
                            <form>
                                <button [localizedRouterLink]="['/'+ nav]" role="button" type="submit"
                                    class="btn-primary ">{{t('anchors.knowYourNeeds')}} </button>
                            </form>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="nav == 'home'">
                        <div>
                            <form class="flex flex-col w-full gap-6 md:flex-row">
                                <button (click)="goToHome()" role="button"
                                    class="btn-primary no-wrap">{{t('anchors.goToHome')}}</button>
                                <button (click)="goToServices()" role="button"
                                    class="btn-secondary">{{t('anchors.discoverOurServices')}}</button>
                            </form>
                            <section class="mt-10 w-full">
                                <app-experts-callback [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
                            </section>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="flex-1 min-h-[355px] w-full on-boarding-bg-1"></div>
        </div>
    </div>
</div> }